@use '../common/colors.scss' as colors;
@use '../common/vars.scss' as vars;

:export {
  documentIconColorUplift: vars.$color-body-text;
  documentIconColorUpgrade: vars.$color-upgrade-logo-primary;
}

.loan-consent-wrapper {
  font-family: 'Rubik', sans-serif;
  font-size: 16px;
  display: flex;
  flex-direction: column;
  width: 100%;

  a {
    color: colors.$link;
  }
}

.body-wrapper {
  display: flex;
  flex-direction: column;
  height: calc(
    100vh - 56px - 48px - 32px
  ); // Calculate document height by subtracting the header, footer, and margin bottom heights respectively
}

.agreements-list {
  padding: 1.3125em 2.625em;
  border-bottom: 1px solid colors.$light-grey;
  display: flex;
  flex-wrap: wrap;
  font-size: 0.9625em;
  flex-shrink: 0; // Issue with older iOS Safari versions not respecting the height of flex divs

  @media screen and (max-width: vars.$mobile) {
    flex-direction: column;
    padding: 0.875em;
  }
}

.agreement-item {
  width: 50%;
  display: flex;
  margin-bottom: 5px;
  align-items: center;

  svg {
    margin-right: 7px;
  }

  @media screen and (max-width: vars.$mobile) {
    width: 100%;
  }
}

:global(.jump-link.active) {
  color: #213ec9;
  text-decoration: underline;
}

:global(.multi-document).document,
:global(.multi-document .container) {
  color: colors.$label;
  width: 100%;
  margin: 0 auto;
  padding: 1em 3em 3em 3em;
  border: none;

  @media screen and (max-width: vars.$mobile) {
    padding: 1em;
  }
}

.loan-consent-footer-wrapper {
  padding-left: 1em;
  padding-right: 1em;
}

.disclaimer-text {
  color: colors.$label;
  text-align: center;
  margin: 10px 0 13px 0;
  font-size: 0.8125em;
  line-height: 16px;
  letter-spacing: -0.3px;

  a:hover {
    color: colors.$uplift-green;
  }
}

.loan-consent-submit {
  width: 100%;
  max-width: 50rem;
  margin: 0 auto;
  font-size: 1.125em;
  padding: 10px 16px;
  color: colors.$white !important;
  background-color: colors.$teal !important;

  &:hover {
    text-decoration: none !important;
    color: colors.$white !important;
    background-color: colors.$teal !important;
  }
}

// Flexpay
:global(.flexpay) {
  .loan-consent-submit {
    background-color: colors.$flexpay-green !important;
  }

  .agreements-list {
    padding: 28px 0 14px 0;

    a {
      color: colors.$flexpay-green;
      text-decoration: none;

      &:hover {
        color: colors.$flexpay-green;
      }
    }
  }

  .agreement-item {
    margin-bottom: 14px;
  }

  .disclaimer-text {
    text-align: left;
    margin: 28px 0;
  }

  :global(.multi-document).document {
    border-style: solid;
    border-width: 0 1px;
    border-color: colors.$flexpay-border;
  }

  .loan-consent-footer-wrapper {
    padding: 0;

    i {
      font-style: normal;
    }
  }

  .wi-notice {
    color: #586272 !important;
    text-align: left;
    font-size: 13px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;

    .wi-notice-header {
      color: #3a3b41;
      font-weight: 500;
      font-size: 16px;
      margin-bottom: 20px;
      padding: 15px 0;
      display: flex;
      justify-content: space-between;
      cursor: pointer;

      svg.is-open {
        transform: rotate(180deg);
        transition: transform 0.3s ease-out;
      }

      svg {
        transition: transform 0.3s ease-out;
      }
    }

    .is-close-notice {
      max-height: 0;
      overflow: hidden;
      transition: max-height 0.3s ease-out, padding 0.3s ease-out;
      border-bottom: 2px solid #b5becc;
      margin-bottom: 20px;
    }

    .is-open-notice {
      max-height: 300px;
      padding-bottom: 10px;
      border-bottom: 2px solid #b5becc;
      margin-bottom: 20px;
    }
  }

  @media screen and (max-width: vars.$mobile) {
    .agreements-list {
      padding-top: 14px;
    }
  }
}
